// extracted by mini-css-extract-plugin
export default {"pageTitle":"text_pageTitle__nIHRk","sectionTitle":"text_sectionTitle__WeoLj"};